import {Input, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {ElementRef} from '@angular/core';
import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  Form,
  FormElement,
  ViewState,
  AppTableComponent,
  MessagesComponent,
  FormElementValidators,
  Auth,
  TranslationEntityComponent, SupplierAuctionOfferService, SearchModel, SearchResultModel

} from 'src/common';
import {SupplierAuctionOfferListModel} from 'src/common';
import {TranslationManager} from 'src/common/translation';

@Component({
  selector: 'app-supplier-auction-offer-list-ssy1280detail',
  templateUrl: 'supplier-auction-offer-list-ssy1280detail.component.html'
})
export class SupplierAuctionOfferListSsy1280detailComponent implements OnInit, AfterViewInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;

  @Input() state: ViewState;
  viewState = ViewState;
  form: Form = new Form();
  translationManager = TranslationManager;
  @ViewChild('translationEntitySupplierAuctionOfferListName') translationEntitySupplierAuctionOfferListName: TranslationEntityComponent;

  itemName: string;
  offeredSupplierAmount: number;
  offeredSupplierPrice: number;
  previousOfferedPrice: number;
  firstOffer: boolean;
  auctionDeadline: Date;
  auctionStartDate: Date;
  isAuctionEnded: boolean = false;
  isAuctionStarted: boolean =false;
  auctionId: number;
  requestRoundSupplierId: number;
  initialOfferedPrice: string;
  displaySubmitModal: boolean;
  // custom-constructor-start

  translationEntityDisplay = false;

  constructor(private router: Router, public route: ActivatedRoute, private el: ElementRef, private supplierAuctionOfferListService: SupplierAuctionOfferService) {
  }


  // custom-constructor-end

  ngAfterViewInit(): void {
    this.DisableTranslationLang();
  }

  ngOnInit(): void {

    if (this.state == ViewState.Create) {
      //   Auth.checkAuthorization('08FF6319-37B9-4EF7-8637-51A0F670EC18');
    } else if (this.state == ViewState.Details) {
      //  Auth.checkAuthorization('59F4080C-537A-43D5-8922-57BE1CBC3744');
    } else if (this.state == ViewState.Edit) {
      //    Auth.checkAuthorization('CC2D49D2-E408-4551-B15E-236F57D344FE');
    }

    this.initForm();
    if (this.state === ViewState.Edit || this.state === ViewState.Details) {
      this.form.elements['requestRoundSupplierId'].value = this.route.snapshot.params.requestRoundSupplierId;
      this.requestRoundSupplierId = this.route.snapshot.params.requestRoundSupplierId;
      this.form.elements['id'].value = this.route.snapshot.params.id;
      this.auctionId = this.route.snapshot.params.id;
      // this.supplierAuctionOfferListService.getById(this.form.elements['id'].value)
      if(this.auctionId) {
        let search = new SearchModel();
        search.filters = [];
        search.filters.push({'entity': "AuctionId", 'value': this.auctionId + '', 'action': "equals"});
        this.supplierAuctionOfferListService.search(search)
          .then((res: any) => {
            let item = res.items[0];

            // MOCK --- START
            // this.item.auctionDeadline = new Date();
            // this.item.auctionDeadline.setSeconds(this.item.auctionDeadline.getSeconds() + 15);
            // MOCK --- END

            this.itemName = item.itemName;
            this.offeredSupplierAmount = item.offeredSupplierAmount;
            this.offeredSupplierPrice = item.offeredSupplierPrice;
            this.auctionDeadline = item.auctionDeadline && (new Date(item.auctionDeadline));
            this.auctionStartDate = item.auctionStartDate && (new Date(item.auctionStartDate));
            this.isAuctionEnded = !this.auctionDeadline && (new Date() >= this.auctionDeadline);
            this.isAuctionStarted = this.auctionStartDate && (new Date() >= new Date(this.auctionStartDate));
            this.previousOfferedPrice = item.offeredPrice;
            !this.previousOfferedPrice && (this.firstOffer = true);

            this.bindModelToForm(item);
          }).catch((reason: any) => {
          if (reason !== null) {
            if (reason.status === 400) {
              if (reason.error !== null) {
                if (reason.error.message) {
                  const mescustom = reason.error.message;
                  MessagesComponent.instance.showError([mescustom]);
                }
              }
            }
          }

        });
      }
    } else if (this.state === ViewState.Create) {
      this.form.elements['requestRoundSupplierId'].value = this.route.snapshot.params.requestRoundSupplierId;
      this.requestRoundSupplierId = this.route.snapshot.params.requestRoundSupplierId;
      this.itemName = this.route.snapshot.queryParams['itemName'];
      this.offeredSupplierAmount = +this.route.snapshot.queryParams['offeredSupplierAmount'];
      this.offeredSupplierPrice = +this.route.snapshot.queryParams['offeredSupplierPrice'];
      this.previousOfferedPrice = +this.route.snapshot.queryParams['previousOfferedPrice'];
      !this.previousOfferedPrice && (this.firstOffer = true);
      const auctionDeadline = this.route.snapshot.queryParams['auctionDeadline'];
      this.auctionDeadline = auctionDeadline && new Date(auctionDeadline);
      this.isAuctionEnded = !this.auctionDeadline || (new Date() >= this.auctionDeadline);

      let search = new SearchModel();
      search.filters = [];
      search.filters.push({'entity': "RequestRoundSupplierId", 'value': this.requestRoundSupplierId + '', 'action': "equals"});

      this.supplierAuctionOfferListService.search(search).then((result: SearchResultModel<SupplierAuctionOfferListModel>) => {
        let obj1 = result.items[0];
        this.form.elements['offeredPrice'].value = obj1?.offeredPrice;
        this.form.elements['offeredAmount'].value = obj1?.offeredAmount;
        // debugger;
        this.initialOfferedPrice = obj1?.offeredPrice;
      });
    }
  }


  private initForm(): void {
    this.initFormCustom();
  }

  private DisableTranslationLang(): void {
    const childNodes = document.querySelectorAll("#containerLangDetails select, #containerLangDetails input, #containerLangDetails textarea, #containerLangDetails button")[Symbol.iterator]() || null;
    if (childNodes) {
      for (var node of childNodes) {
        node.disabled = true;
      }
    }
  }

  private bindModelToForm(item: SupplierAuctionOfferListModel): void {
    this.bindModelToFormCustom(item);
  }


  fillModel(model) {
    model['id'] = this.form.elements['id'].value;
    model['requestRoundSupplierId'] = this.form.elements['requestRoundSupplierId'].value;
    model['itemName'] = this.form.elements['itemName'].value;
    model['offeredSupplierAmount'] = this.form.elements['offeredSupplierAmount'].value;
    model['offeredSupplierPrice'] = this.form.elements['offeredSupplierPrice'].value;
    model['offeredAmount'] = this.form.elements['offeredAmount'].value;
    model['offeredPrice'] = this.form.elements['offeredPrice'].value;
    model['auctionStartDate'] = this.form.elements['auctionStartDate'].value;
    if (this.translationEntityDisplay) {
      model.translationName = this.translationEntitySupplierAuctionOfferListName.entity;
    }

  }

  initFormCustom() {
    this.form.elements["id"] = new FormElement();
    this.form.elements['requestRoundSupplierId'] = new FormElement();
    this.form.elements['itemName'] = new FormElement();
    this.form.elements['itemName'].state.mandatory = false;
    this.form.elements['offeredSupplierAmount'] = new FormElement();
    this.form.elements['offeredSupplierAmount'].state.mandatory = false;
    this.form.elements['offeredSupplierPrice'] = new FormElement();
    this.form.elements['offeredSupplierPrice'].state.mandatory = false;
    this.form.elements['offeredAmount'] = new FormElement();
    this.form.elements['offeredAmount'].state.mandatory = false;
    this.form.elements['offeredPrice'] = new FormElement();
    this.form.elements['offeredPrice'].state.mandatory = true;
    this.form.elements['auctionStartDate'] = new FormElement();
    this.form.elements['auctionStartDate'].state.mandatory = true;
  }

  bindModelToFormCustom(item) {
    this.form.elements['id'].value = item.auctionId;
    this.form.elements['requestRoundSupplierId'].value = item.requestRoundSupplierId;
    this.form.elements['itemName'].value = item.itemName;
    this.form.elements['offeredSupplierAmount'].value = item.offeredSupplierAmount;
    this.form.elements['offeredSupplierPrice'].value = item.offeredSupplierPrice;
    /* TEST */
    // this.form.elements['offeredSupplierPrice'].value = 100;
    // this.offeredSupplierPrice = 100;
    // NINA: ZORANIN ZAHTEV DA offeredAmount BUDE UVEK ISTI KAO offeredSupplierAmount
    // this.form.elements['offeredAmount'].value = item.offeredAmount;
    this.form.elements['offeredAmount'].value = item.offeredSupplierAmount;
    this.form.elements['offeredPrice'].value = item.offeredPrice;

    this.form.elements['auctionStartDate'].value = item.auctionStartDate;

    this.form.elements['offeredPrice'].error['bigPriceError'] = false;
    this.form.elements['offeredPrice'].error['equalsZeroError'] = false;

    if (this.form.elements['offeredPrice'].value === 0) {
      this.form.elements['offeredPrice'].error['equalsZeroError'] = true;
    } else if (this.form.elements['offeredPrice'].value > this.offeredSupplierPrice || (!this.firstOffer && this.form.elements['offeredPrice'].value > this.previousOfferedPrice)) {
      this.form.elements['offeredPrice'].error['bigPriceError'] = true;
    }

    if (item['translationName']) {
      this.translationEntitySupplierAuctionOfferListName.entity = item['translationName'];
    }
  }

  navigateToList(): void {
    this.router.navigate(['auctions']);
  }

  checkSubmit() {
    if (this.form.isValid() && (!this.translationEntityDisplay || this.translationEntitySupplierAuctionOfferListName.isValid())) {
      let offeredPrice = this.form.elements['offeredPrice'].value;
      if (!this.previousOfferedPrice || this.previousOfferedPrice == offeredPrice) {
        this.submit();
      } else {
        this.displaySubmitModal = true;
      }
    } else {
      for (const jjj of Object.keys(this.form.elements)) {
        if (this.form.elements[jjj].error.required || this.form.elements[jjj].error.invalid) {
          const invalidControl = this.el.nativeElement.querySelector('[name="' + jjj + '"]');
          this.form.elements[jjj].state.dirty = true;
          invalidControl.focus();
          break;
        }
      }
    }
  }

  submit(): void {

    if (this.form.isValid() && (!this.translationEntityDisplay || this.translationEntitySupplierAuctionOfferListName.isValid())) {
      const model: SupplierAuctionOfferListModel = new SupplierAuctionOfferListModel();

      this.fillModel(model);

      if (this.state === ViewState.Create) {
        this.supplierAuctionOfferListService.save(model).then(() => {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно сачуван ентитет')]);
          this.router.navigate(['auctions']);
        }).catch((reason: any) => {
          if (reason !== null) {
            if (reason.status === 400) {
              if (reason.error !== null) {
                if (reason.error.message) {
                  const mescustom = reason.error.message;
                  MessagesComponent.instance.showError([mescustom]);

                } else if (reason.error.messages) {
                  MessagesComponent.instance.showError(reason.error.messages);
                }
              }
            } else {
              MessagesComponent.instance.showError(reason.error.messages);
            }
            this.displaySubmitModal = false;
          }
        });
      } else if (this.state === ViewState.Edit) {
        this.supplierAuctionOfferListService.save(model).then(() => {
          MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно измењен ентитет')]);
          this.router.navigate(['auctions']);
        }).catch((reason: any) => {
          if (reason !== null) {
            if (reason.status === 400) {
              if (reason.error !== null) {
                if (reason.error.message) {
                  const mescustom = reason.error.message;
                  MessagesComponent.instance.showError([mescustom]);
                } else if (reason.error.messages) {
                  MessagesComponent.instance.showError(reason.error.messages);
                }
              }
            } else {
              MessagesComponent.instance.showError(reason.error.messages);
            }
            this.displaySubmitModal = false;
          }
        });
      }
    }
    else {
            for (const jjj of Object.keys(this.form.elements)) {
                if (this.form.elements[jjj].error.required || this.form.elements[jjj].error.invalid) {
                    const invalidControl = this.el.nativeElement.querySelector('[name="' + jjj + '"]');
                    invalidControl.focus();
                    break;
                }
            }
        }
  }

  auctionEnded(obj) {
    this.isAuctionEnded = !this.auctionDeadline && (new Date() >= this.auctionDeadline);
  }

  onFormInput(key: string) {
    try {

      if (key === 'offeredPrice') {
        this.form.elements[key].error['bigPriceError'] = false;
        this.form.elements[key].error['equalsZeroError'] = false;

        if (this.form.elements[key].value === 0) {
          this.form.elements[key].error['equalsZeroError'] = true;
        } else if (this.form.elements[key].value > this.offeredSupplierPrice || (!this.firstOffer && this.form.elements[key].value > this.previousOfferedPrice)) {
          this.form.elements[key].error['bigPriceError'] = true;
        }
      }

      setTimeout(() => {
        this.form.elements[key].state.dirty = true;
      });
    } catch(error) {}
  }

}
